module.exports = __webpack_public_path__ + "static/media/visionmission.e67446d0.svg";